import React, { useContext } from 'react';
import ToastContext from '../../../contextProvider/ToastContext';
import Alert from '../alert';

const Alerts = () => {
  const toastCtx = useContext(ToastContext);
  const { alerts } = toastCtx;

  return (
    <>
      {alerts.map((alert) => (
        <Alert alert={alert} key={alert.id} cls={alert.class} />
      ))}
    </>
  );
};

export default Alerts;
